import { createLocale } from "./createLocale";

export const sk = createLocale({
  header: {
    title: "Choďte globálne. 2 $ za Short. Akýkoľvek jazyk!",
    subtitle: "🔥Plaťte len za výsledok – od $0.089 do $0.009 za sekundu🔥",
  },
  steps: {
    uploadVideo: "Nahrať video",
    selectLanguages: "Vybrať jazyky",
    conversionResult: "Konverzia a výsledok",
  },
  upload: {
    dragAndDrop: "Presuňte sem svoj video súbor",
    orClickToSelect: "alebo kliknite pre výber",
    supportedFormats: "Podporované formáty: MP4, AVI, MOV, MKV, WebM",
    maxFileSize: "• Maximálna veľkosť súboru: 200 MB",
    maxDuration: "• Maximálna dĺžka: 30 s",
    chooseFile: "Vybrať súbor",
    selectedFile: "Vybraný súbor:",
    size: "Veľkosť:",
    fileTypeError: "Prosím, vyberte video súbor",
    fileSizeError: "Veľkosť súboru ({size} MB) presahuje maximálny limit 200 MB",
    durationError: "Dĺžka videa ({duration} s) presahuje maximálny limit 30 s",
    fileReadError: "Video súbor sa nepodarilo načítať. Skúste iný súbor.",
  },
  languages: {
    sourceAudioLanguage: "Jazyk zdrojového audia",
    targetAudioLanguage: "Jazyk cieľového audia",
    selectLanguage: "Vyberte jazyk...",
  },
  conversion: {
    replaceAudio: "Naklonovať môj hlas",
    uploadVideoAndSelectLanguages: "Nahrajte video a vyberte jazyky pre pokračovanie",
  },
  nav: {
    blog: "Blog",
  },
  footer: {
    privacyPolicy: "Zásady ochrany osobných údajov",
    termsOfUse: "Podmienky používania",
  },
  languageOptions: {
    sk: "Slovenčina",
  },
});
